// extracted by mini-css-extract-plugin
export default {"filterBar":"ActivityTypeFilter_filterBar__SCAHd","label":"ActivityTypeFilter_label__ulUN9","chips":"ActivityTypeFilter_chips__cl8+5"};